import React, { useState, useEffect } from 'react'
import styled, { withTheme } from 'styled-components'
import { get } from 'lodash'

import Dropdown from '../dropdown'
import Menu from '../menu'
import Input from '../input'
import Select from '../select'
import TreeSelect from '../tree-select'
import Icon from '../tntd-icon'
import { getCurrentAppStore, setCurrentAppStore } from './storage'
import { traverseTree } from '../utils'

const { Option } = Select
const MenuList = styled(Menu)`
  border-radius: 0;
  min-width: 250px;
  max-height: 350px;
  overflow-y: auto;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2) !important;
  .ant-dropdown-menu-item {
    padding: 0 20px;
    height: 44px;
    line-height: 44px;
    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
    &.app-search-warp {
      padding: 0;
      &:hover {
        background: none;
      }
      .ant-input-affix-wrapper {
        height: 100%;
      }
      .ant-input {
        border: none;
        border-bottom: 1px dashed #dcdcdc;
        box-shadow: none;
        padding: 0 20px;
      }
    }
    i {
      margin-right: 0 !important;
      margin-left: 6px !important;
    }
  }
  .isInIframe & {
    margin-left: 20px;
  }
`

// 新版UI
const AppsSelect = styled(Select)`
  min-width: 160px;
  height: 28px;
  line-height: 28;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  .ant-select-selection,
  .ant-select-selection__rendered {
    line-height: 28px;
    height: 28px;
  }

  .ant-select-selection {
    .hasHeaderTabs & {
      border-radius: 14px;
      font-size: 12px;
      // 去掉默认黑色
      // background: #191D29;
      // border: 1px solid rgba(186,189,197,0.60);
      // color: rgba(255,255,255,.8);
      // 统一为浅色调
      background: #fff !important;
      border-color: #c9d2dd !important;
      color: #8b919e !important;
    }
    // 统一色调
    // .tnt-themeS1.hasHeaderTabs & {
    //     /* background: #141825; */
    //     /* color: rgba(255,255,255,.85); */
    //     background: #fff;
    //     border-color: #c9d2dd;
    //     color: #8b919e;
    // }

    // .tnt-themeS3.hasHeaderTabs &{
    //     background: ${(props) => `${props.theme.blueBgColor} !important`}; //#1D4295
    //     color: rgba(255,255,255,0.8);
    //     border-color: rgba(255,255,255,0.5);
    // }
  }

  .ant-select-arrow {
    .hasHeaderTabs & {
      color: #b2becd;
    }
    .tnt-themeS1 & {
      /* color: rgba(255,255,255,.85); */
    }
  }

  .tnt-themeS1 & {
    border-radius: 2px;
  }

  .isInIframe & {
    margin-left: 20px;
  }
`

const AppTreeSelect = styled(TreeSelect)`
  min-width: 160px;
  height: 28px;
  line-height: 28;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
`

const SwitchAppMenu = styled.a`
  display: block;
  color: #666;
  line-height: ${(props) => `${props.theme.headerHeight}px`};
  font-size: ${(props) => `${props.theme.size === 'large' ? 16 : 14}px`};

  .tnt-themeS1 & {
    color: rgba(255, 255, 255, 0.85);
  }
  &:hover {
    color: #666;
  }
  i {
    margin-left: 12px;
  }
`

export default withTheme((props) => {
  const { selectedKey, items = [], onChange } = props
  const getInitialSelectedApp = () => {
    const currentAppStore = getCurrentAppStore()
    const findAppByKey = (selectedKey) => {
      let findApp

      traverseTree(items, (item) => {
        if (item.key === selectedKey) {
          findApp = item
          return false
        }
      })

      return findApp
    }
    const currentApp = findAppByKey(selectedKey || get(currentAppStore, 'key'))

    return currentApp || items[0]
  }
  const changeApp = (app) => {
    setSelectedApp(app)
    setCurrentAppStore(app)
    onChange && onChange(app)
  }

  const [searchValue, setSearchValue] = useState()
  const [selectedApp, setSelectedApp] = useState(getInitialSelectedApp())
  const Menus = (
    <MenuList selectedKeys={[get(selectedApp, 'key')]}>
      <Menu.Item className="app-search-warp" key="search" disabled>
        <Input
          allowClear
          placeholder="输入关键词搜索"
          value={searchValue}
          onChange={(evt) => {
            setSearchValue(evt.target.value)
          }}
        />
      </Menu.Item>
      {items
        .filter(({ key, name } = {}) => {
          const regExp = new RegExp(searchValue, 'i')
          if (searchValue) {
            return regExp.test(key) || regExp.test(name)
          }
          return true
        })
        .map((item) => (
          <Menu.Item key={item.key} onClick={changeApp.bind(this, item)}>
            {item.name}
          </Menu.Item>
        ))}
    </MenuList>
  )

  useEffect(() => {
    const newApp = getInitialSelectedApp()

    if (newApp?.key !== selectedApp?.key) {
      changeApp(newApp)
    }
  }, [items, selectedKey])

  if (!props.theme.compatible) {
    if (items?.some((item) => item.children?.length)) {
      return (
        <AppTreeSelect
          placeholder="请选择"
          showSearch
          treeNodeFilterProp="title"
          treeDefaultExpandAll
          dropdownClassName="tnt-layout-header-app-tree-select"
          dropdownStyle={{ maxHeight: 560 }}
          value={get(selectedApp, 'key')}
          treeData={traverseTree(items, (item) => {
            item.title = item.name
            item.value = item.key
            item.selectable = !item.children
            item.disabled = !!item.children
          })}
          onChange={(appKey) => {
            let findItem

            traverseTree(items, (node) => {
              if (node.key === appKey) {
                findItem = node
                return false
              }
            })
            changeApp(findItem)
          }}
          style={{ minWidth: 160, height: 28, lineHeight: 28 }}
        />
      )
    }

    return (
      <AppsSelect
        placeholder="请选择"
        showSearch
        optionFilterProp="children"
        value={get(selectedApp, 'key')}
        onChange={(appKey) => {
          changeApp(items.find(({ key }) => key === appKey))
        }}
        style={{ minWidth: 160, height: 28, lineHeight: 28 }}
      >
        {items.map(({ key, name }) => (
          <Option key={key} value={key}>
            {name}
          </Option>
        ))}
      </AppsSelect>
    )
  }

  return (
    <Dropdown overlay={Menus} trigger={['click']}>
      <SwitchAppMenu>
        <span>{get(selectedApp, 'name', '请选择')}</span>
        <Icon type="caret-down" />
      </SwitchAppMenu>
    </Dropdown>
  )
})
